export default __webpack_public_path__ + "static/thomas-a9b15f836c2f8ea180424125a188c774.jpeg";